import {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {ButtonGroup, Dropdown} from "react-bootstrap";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import DataRange from "components/datetime/DataRange";
import moment from "moment";
import useCustomTranslation from "core/customTranslation";
import translations from "../translations";
import SearchSelect from "components/selects/SearchSelect";

const FiltersProgramming = ({
    onFilterChange = () => {},
    initialFilters = {},
    filterOptions = {
        groups: [],
        zones: [],
        routes: [],
        islands: [],
    },
    counter,
    // onApplyFilters = () => {},
    reportType = "cp",
}) => {
    const {t: tC} = useCustomTranslation(translations);
    const {t: _tT} = useTranslation("tags");

    const defaultEndDate = new Date();
    const defaultStartDate = new Date();
    defaultStartDate.setDate(defaultStartDate.getDate() - 7);

    const [filters, setFilters] = useState({
        min: 1,
        max: 100,
        ...initialFilters,
    });
    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [dataRangeSelected, setDataRangeSelected] = useState(
        `${moment(defaultStartDate).format("DD/MM/YYYY")} - ${moment(
            defaultEndDate
        ).format("DD/MM/YYYY")}`
    );

    useEffect(() => {
        if (initialFilters && Object.keys(initialFilters).length > 0) {
            setFilters({
                min: 1,
                max: 100,
                ...initialFilters,
            });

            if (initialFilters.dateRange) {
                const startDate = initialFilters.dateRange.startDate
                    ? moment(initialFilters.dateRange.startDate, "DD/MM/YYYY").toDate()
                    : defaultStartDate;
                const endDate = initialFilters.dateRange.endDate
                    ? moment(initialFilters.dateRange.endDate, "DD/MM/YYYY").toDate()
                    : defaultEndDate;

                setDateRange([startDate, endDate]);
                setDataRangeSelected(
                    `${moment(startDate).format("DD/MM/YYYY")} - ${moment(
                        endDate
                    ).format("DD/MM/YYYY")}`
                );
            }
        }
    }, [JSON.stringify(initialFilters)]);

    useEffect(() => {
        const formattedDateRange = {
            startDate: dateRange[0] ? moment(dateRange[0]).format("DD/MM/YYYY") : "",
            endDate: dateRange[1] ? moment(dateRange[1]).format("DD/MM/YYYY") : "",
        };

        const filtersWithDate = {
            ...filters,
            dateRange: formattedDateRange,
        };

        onFilterChange(filtersWithDate);
    }, [filters, dateRange]); // Removido onFilterChange de las dependencias

    const onChangeSelect = (e) => {
        const {name, value} = e.target;

        const newFilters = {...filters};

        if (["min", "max"].includes(name)) {
            if (value) {
                let numValue = parseInt(value);
                numValue = Math.max(1, Math.min(numValue, 100));

                if (name === "min") {
                    numValue = Math.min(numValue, filters.max || 100);
                } else {
                    numValue = Math.max(numValue, filters.min || 1);
                }

                newFilters[name] = numValue;
            } else {
                newFilters[name] = name === "min" ? 1 : 100;
            }
        } else {
            value ? (newFilters[name] = value) : delete newFilters[name];
        }

        setFilters(newFilters);
    };

    const handleClearFilters = () => {
        setFilters({
            min: 1,
            max: 100,
        });

        const newDefaultEndDate = new Date();
        const newDefaultStartDate = new Date();
        newDefaultStartDate.setDate(newDefaultStartDate.getDate() - 7);

        setDateRange([newDefaultStartDate, newDefaultEndDate]);
        setDataRangeSelected(
            `${moment(newDefaultStartDate).format("DD/MM/YYYY")} - ${moment(
                newDefaultEndDate
            ).format("DD/MM/YYYY")}`
        );
    };

    // const selectDataRange = (start, end) => {
    //     setDateRange([start, end]);
    //     const formattedStart = start ? moment(start).format("DD/MM/YYYY") : "";
    //     const formattedEnd = end ? moment(end).format("DD/MM/YYYY") : "";
    //     setDataRangeSelected(`${formattedStart} - ${formattedEnd}`);
    // };

    // const clearDateRange = () => {
    //     const newDefaultEndDate = new Date();
    //     const newDefaultStartDate = new Date();
    //     newDefaultStartDate.setDate(newDefaultStartDate.getDate() - 7);

    //     setDateRange([newDefaultStartDate, newDefaultEndDate]);
    //     setDataRangeSelected(
    //         `${moment(newDefaultStartDate).format("DD/MM/YYYY")} - ${moment(
    //             newDefaultEndDate
    //         ).format("DD/MM/YYYY")}`
    //     );
    // };

    const labelStyle = {
        fontWeight: "bold",
        textAlign: "center",
        display: "block",
    };

    return (
        <div id="filter-collapse">
            <div className="row">
                <Button
                    variant="link"
                    type="button"
                    onClick={handleClearFilters}
                    style={{color: "black"}}
                    className="col-1">
                    <FontAwesomeIcon icon="filter-circle-xmark" />
                </Button>

                <div className="col" style={{maxWidth: "160px"}}>
                    <label style={labelStyle}>{_tT("common.download")} </label>
                    <DownloadTypesSelect
                        onChange={onChangeSelect}
                        value={filters.download_type || ""}
                    />
                </div>

                <div className="col" style={{maxWidth: "160px"}}>
                    <label style={labelStyle}>{tC("filters.wasteType")}</label>
                    <WasteTypesSelect
                        onChange={onChangeSelect}
                        value={filters.waste_type || ""}
                    />
                </div>

                <div className="col" style={{maxWidth: "200px"}}>
                    <label style={labelStyle}>{tC("filters.groups")}</label>
                    <SearchSelect
                        options={[
                            {value: "", label: tC("filters.all")},
                            ...filterOptions.groups.map((group) => ({
                                value: group.id,
                                label: group.name,
                            })),
                        ]}
                        placeholder={tC("filters.all")}
                        onChange={(option) => {
                            const newFilters = {...filters};
                            if (option && option.value) {
                                newFilters.group = option.value;
                            } else {
                                delete newFilters.group;
                            }
                            setFilters(newFilters);
                        }}
                        value={
                            filterOptions.groups
                                .filter((g) => g.id === filters.group)
                                .map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                }))[0] || null
                        }
                    />
                </div>

                <div className="col" style={{maxWidth: "200px"}}>
                    <label style={labelStyle}>{tC("filters.zones")}</label>
                    <SearchSelect
                        options={[
                            {value: "", label: tC("filters.all")},
                            ...filterOptions.zones.map((zone) => ({
                                value: zone.id,
                                label: zone.name,
                            })),
                        ]}
                        placeholder={tC("filters.all")}
                        isClearable={true}
                        onChange={(option) => {
                            const newFilters = {...filters};
                            if (option && option.value) {
                                newFilters.zone = option.value;
                            } else {
                                delete newFilters.zone;
                            }
                            setFilters(newFilters);
                        }}
                        value={
                            filterOptions.zones
                                .filter((z) => z.id === filters.zone)
                                .map((z) => ({
                                    value: z.id,
                                    label: z.name,
                                }))[0] || null
                        }
                    />
                </div>

                <div className="col" style={{maxWidth: "200px"}}>
                    <label style={labelStyle}>{tC("filters.routes")}</label>
                    <SearchSelect
                        options={[
                            {value: "", label: tC("filters.all")},
                            ...filterOptions.routes.map((route) => ({
                                value: route.id,
                                label: route.name,
                            })),
                        ]}
                        placeholder={tC("filters.all")}
                        isClearable={true}
                        onChange={(option) => {
                            const newFilters = {...filters};
                            if (option && option.value) {
                                newFilters.route = option.value;
                            } else {
                                delete newFilters.route;
                            }
                            setFilters(newFilters);
                        }}
                        value={
                            filterOptions.routes
                                .filter((r) => r.id === filters.route)
                                .map((r) => ({
                                    value: r.id,
                                    label: r.name,
                                }))[0] || null
                        }
                    />
                </div>

                <div className="col" style={{maxWidth: "200px"}}>
                    <label style={labelStyle}>{tC("filters.islands")}</label>
                    <SearchSelect
                        options={[
                            {value: "", label: tC("filters.all")},
                            ...filterOptions.islands.map((island) => ({
                                value: island.id,
                                label: island.name,
                            })),
                        ]}
                        placeholder={tC("filters.all")}
                        isClearable={true}
                        onChange={(option) => {
                            const newFilters = {...filters};
                            if (option && option.value) {
                                newFilters.island = option.value;
                            } else {
                                delete newFilters.island;
                            }
                            setFilters(newFilters);
                        }}
                        value={
                            filterOptions.islands
                                .filter((i) => i.id === filters.island)
                                .map((i) => ({
                                    value: i.id,
                                    label: i.name,
                                }))[0] || null
                        }
                    />
                </div>
                <div className="col-1">
                    <label style={labelStyle}>&nbsp;</label>
                    {/* <button
                        type="button"
                        onClick={onApplyFilters}
                        className="btn btn-outline-primary"
                        title="Aplicar">
                        <FontAwesomeIcon icon="magnifying-glass" />{" "}
                        {tC("filters.search")}
                    </button> */}
                </div>
            </div>

            <div className="row mt-3">
                {/* <div className="col-1"></div> */}
                <div className="col-1 h5 pt-3 text-center">
                    {/* {counter ? tC("filters.found") + counter : tC("filters.noData")} */}
                </div>
                <div className="col" style={{maxWidth: "250px"}}>
                    <label style={labelStyle}>{tC("filters.containerUID")}</label>
                    <input
                        type="text"
                        className="form-control"
                        name="uid"
                        onChange={onChangeSelect}
                        value={filters.uid || ""}
                    />
                </div>

                <div className="col" style={{maxWidth: "250px"}}>
                    <label style={labelStyle}>{tC("filters.deviceUUID")}</label>
                    <input
                        type="text"
                        className="form-control"
                        name="uuid"
                        onChange={onChangeSelect}
                        value={filters.uuid || ""}
                    />
                </div>

                {reportType !== "pr" && (
                    <div className="col" style={{maxWidth: "260px"}}>
                        <label style={labelStyle}>{tC("filters.fillLevel")}</label>
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="min"
                                    placeholder={tC("filters.minimum")}
                                    onChange={onChangeSelect}
                                    value={filters.min || 1}
                                />
                            </div>
                            <div className="col" style={{maxWidth: "260px"}}>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="max"
                                    placeholder={tC("filters.maximum")}
                                    onChange={onChangeSelect}
                                    value={filters.max || 100}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* <div className="col" style={{maxWidth: "260px"}}>
                    <label style={labelStyle}>{tC("filters.date")}</label>
                    <ButtonGroup className="w-100">
                        <Dropdown className="w-100">
                            <Dropdown.Toggle
                                variant="Secondary"
                                id="dropdown-basic"
                                style={{
                                    border: "1px solid #ced4da",
                                    minWidth: "100%",
                                }}
                                className="custom-dropdown-toggle">
                                <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                <label style={{width: "90%", textAlign: "center"}}>
                                    {" "}
                                    {dataRangeSelected}
                                </label>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <DataRange
                                    rangeData={selectDataRange}
                                    maxSpan={30}
                                    maxDate={new Date()}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </ButtonGroup>
                </div> */}

                {/* <div className="col-1">
                    <label style={labelStyle}>&nbsp;</label>
                    <Button
                        variant="link"
                        type="button"
                        onClick={clearDateRange}
                        style={{color: "black"}}
                        className="btn-outline-secondary"
                        title={tC("filters.clearDates")}>
                        <FontAwesomeIcon icon="xmark" />
                    </Button>
                </div> */}
            </div>
        </div>
    );
};

export default FiltersProgramming;
